@if (showSeparateRightButton) {
  <div class="btn-container">
    <button [type]="type" [disabled]="disable" class="{{ className }} btn btn-split-main" attr.aria-label="{{ ariaLabel }}">
      @if (icon && iconPosition === 'left') {
        <fa-icon [icon]="icon" [size]="iconSize" aria-hidden="true" />
      }
      <ng-container i18n>{{ label }}</ng-container>
    </button>
    <span class="btn-separator"></span>
    <button
      type="button"
      class="{{ className }} btn btn-icon-button"
      [class.activeBtn]="isOpenMenu"
      (click)="onIconClick($event)"
      [attr.aria-label]="menuAriaLabel || 'Open menu'"
      i18n-aria-label
    >
      @if (icon) {
        <fa-icon [icon]="icon" [size]="iconSize" aria-hidden="true" />
      }
    </button>
  </div>
} @else {
  <button [type]="type" [disabled]="disable" class="{{ className }}" attr.aria-label="{{ ariaLabel }}">
    @if (icon && iconPosition === 'left') {
      <fa-icon [icon]="icon" [size]="iconSize" aria-hidden="true" />
    }
    <ng-container i18n>{{ label }}</ng-container>
    @if (icon && iconPosition === 'right') {
      <fa-icon [icon]="icon" [size]="iconSize" aria-hidden="true" />
    }
  </button>
}
